export default __webpack_public_path__ + "static/media/kitchen3-afterD-768w.5bdb538d.png";